import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Title from '../ui/title'
import Content from '../ui/content'
import Context from './context'
import Toolbar from './toolbar'

import { dateTimeFormatter, getISODateString } from '../../common/utils'
import Table from '../table'

import MuiPickersUtilsProvider
    from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import DatePicker from 'material-ui-pickers/DatePicker'
import moment from 'moment'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
import ConfirmDialog from '../common/dialog/confirm'
moment.suppressDeprecationWarnings = true;


class RestoreJobs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedJobs: [],
            selectAll: false,
            contextMenu: false,
            columns: null,
            selected: {},
            filterable: false,
            selectedDateTime: null,
            showConfirmRestore: false,
        }
        this.toggle = this.toggle.bind(this)
        this.toggleColumns = this.toggleColumns.bind(this)
        this.onRestoreJob = this.onRestoreJob.bind(this)
        this.refreshList = this.refreshList.bind(this)
        this.showConfirmRestore = this.showConfirmRestore.bind(this)
        this.hideConfirmRestore = this.hideConfirmRestore.bind(this)
        this.toggleFilters = this.toggleFilters.bind(this)
        this.selectedRows = this.selectedRows.bind(this)
    }

    componentWillMount() {
        const { jobs, pager, translate } = this.props
        const { defaultColumns } = pager
        const { filterable } = this.state
        let columns = []
        if (jobs && jobs.columns) {
            jobs.columns = jobs.columns.sort((a, b) => b.field.localeCompare(a.field))
        }
        jobs && jobs.columns.forEach(column => {
            if (column.field === "recoveryname") {
                columns.push({
                    id: column.field,
                    Header: translate("name"),
                    accessor: d => d[column.field],
                    show: defaultColumns.includes(column.field),
                    filterable: column.cansearch && filterable,
                    cansearch: column.cansearch,
                    sortable: column.cansort,
                    display: column.display
                })
            } else {
                columns.push({
                    id: column.field,
                    Header: translate(column.field),
                    accessor: d => d[column.field],
                    show: defaultColumns.includes(column.field),
                    filterable: column.cansearch && filterable,
                    cansearch: column.cansearch,
                    sortable: column.cansort,
                    display: column.display
                })
            }
        })
        this.setState({
            columns: columns
        })
    }

    showConfirmRestore(jobId) {
        const { jobs } = this.props
        let data = jobs.data ? jobs.data.find(x => x.id == jobId) : null
        this.setState({
            currentRow: data,
            showConfirmRestore: true
        })
    }

    hideConfirmRestore() {
        this.setState({
            currentRow: null,
            showConfirmRestore: false
        })
    }

    onRestoreJob() {
        this.props.restoreDeletedJob(this.state.currentRow.id, this.props.pager)
        this.setState({
            selected: {}
        })
        this.hideConfirmRestore();
    }

    refreshList() {
        this.props.refresh()
    }

    render() {
        const { translate, jobs, fetch, pager, impersonating, softwareUpdate } = this.props
        const { selected } = this.state
        let selectedRecords = Object.keys(selected).filter(x => selected[x])

        let margintop = "150px";

        if (impersonating && softwareUpdate) {
            margintop = "275px";
          } else if (impersonating || softwareUpdate) {
            margintop = "215px";
          }

        const _selected = { ...selected }

        let $context = (
            <Context
                toggleColumns={this.toggleColumns}
                data={jobs.data}
                translate={translate}
                columns={this.state.columns}
            />
        )

        let confirmText = translate('restore_job_confirm_text', { name: this.state.currentRow ? this.state.currentRow.recoveryname : '' })

        return (
            <div style={{marginTop: margintop}}>
                <div>
                    <Title
                        title={translate('general_jobs')}
                        toolbar={
                            <Toolbar
                                translate={translate}
                                toggle={() => this.toggle()}
                                selectedRecords={selectedRecords}
                                toggleFilters={this.toggleFilters}
                                restoreJob={(selectedRecords && selectedRecords.length) ? (() => this.showConfirmRestore(selectedRecords[0])) : null}
                                refresh={this.refreshList}
                            />
                        }
                    />
                    <Content
                        ctx={$context}
                        open={this.state.contextMenu}
                        toggle={() => this.toggle()}
                        translate={translate}
                    >
                        <Table
                            translate={translate}
                            filterable
                            pages={jobs.pagecount}
                            manual={pager.manual}
                            minRows={0}
                            pager={pager}
                            defaultPageSize={pager.pagesize}
                            data={jobs.data}
                            columns={this.state.columns}
                            fetch={fetch}
                            allowSelectOne
                            selectedRows={this.selectedRows}
                            selected={_selected}
                            style={{
                                border: 'none'
                            }}
                            noDataText="no_data_restore_job"
                        />
                        <ConfirmDialog
                            open={this.state.showConfirmRestore}
                            title={translate('restore_job_confirm_title')}
                            contentText={confirmText}
                            contentSecondaryText={translate('general_confirmation_help_2')}
                            okText={translate('general_confirm')}
                            cancelText={translate('general_cancel')}
                            onOk={this.onRestoreJob}
                            onCancel={this.hideConfirmRestore}
                        />
                    </Content>
                </div>
            </div>
        )
    }

    selectedRows(rows) {
        this.setState({
            selected: rows
        })
    }

    toggle() {
        this.setState({
            contextMenu: !this.state.contextMenu
        })
    }

    toggleColumns(column) {
        let columns = [...this.state.columns]

        columns.forEach(c => {
            if (c.id === column.id) {
                c.show = column.show
            }
        })
        this.setState({
            columns: columns
        })
    }

    toggleFilters() {
        let columns = [...this.state.columns]
        let { filterable } = this.state
        columns.forEach(c => {
            c.filterable = c.cansearch && !filterable
        })
        this.setState({
            columns: columns,
            filterable: !filterable
        })
    }

    setColumns() {
        const { columns } = this.state
        this.setState({
            columns: columns
        })
    }

    componentWillReceiveProps(nextProps) {
        const props = { ...nextProps }
        this.setColumns(props)
    }
}

const mapStateToProps = (state) => ({
    impersonating: state.userReducer.impersonating,
    softwareUpdate: state.userReducer.softwareUpdate,
    ...state,
  });
  
  export default compose(
    withStyles(styles),
    connect(mapStateToProps),
  )(RestoreJobs);